<template>

    <div class="upload">

      <el-button class="back_btn" type="text"icon="el-icon-arrow-left" style="color:#fff;" @click="hanadleBack">返回</el-button>

      <div class="title">{{(type == 'material' && uploading != '')? "重新"+upload.title:upload.title}}</div>

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px">
        <!--解决上传场景只有一个输入框，输入回车的刷新问题-->
        <input style="width:0px;height:0px;position:relative;top:-1000px;background:#303030;">
        <el-form-item :label="upload.name" style="color:#fff;" prop="name">
          <el-input style="width:400px;" v-model="ruleForm.name" :placeholder="upload.name_placehodler" v-show="uploading == ''"></el-input>
          <div style="color:#fff;" v-show="uploading != ''">{{this.uploading.title}}</div>
        </el-form-item>

        <el-form-item :label="upload.type" prop="type" v-if="upload.type_list.length > 0">
          <el-select v-model="ruleForm.type" placeholder="请选择" style="width:400px">
            <el-option v-for="item, index in upload.type_list" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="upload.title" prop="name">
          <el-upload
            class="upload-demo"
            :action="upload.url"
            :on-progress = "handleProgress"
            :before-upload = "handleBeforeUpload"
            :headers="header"
            :show-file-list ="false"
            :on-success = "hanldeSuccess"
            style="float:left;">
            <span v-if="file_name != ''" style="color:#fff;">{{file_name}}</span>
            <el-button class="upload-btn" size="small" type="primary" :loading="upload_loading" :disabled="upload_status">上传</el-button>
          </el-upload>
          <!-- <span class="video-play" v-if="type == 'material'" @click="handleVideoPlay('0')">人物模板教程 </span><span class="video-play" v-if="type == 'material'" @click="handleVideoPlay('1')"> 人物上传教程</span><span v-if="type == 'scene'" class="video-play" @click="handleVideoPlay('2')"> 场景教程</span> -->
        </el-form-item>

        <div style="min-height:60px;margin-left:110px;color:#fff;">
          <div class="percent" v-show="percent > 0">上传中{{percent}}%</div>
          <div class="progress" v-show="percent > 0">
            <div :style="getWidth"></div>
          </div>
          <div style="color:red;line-height:20px" v-for="item in error_info">{{item}}</div>
        </div>
        <el-form-item >
          <el-button class="save-btn" @click="handleSave('ruleForm')" type="success" :loading="save_status" :disabled="saveStatus">保存</el-button>
        </el-form-item>
      </el-form>

      <el-dialog v-model="dialog_video_visible" :visible.sync="dialog_video_visible">
        <video id="video_upload" :src="video_url" controls width="100%" autoplay></video>
      </el-dialog>
    </div>
</template>

<script>

  export default {
    name: 'upload',
    computed: {

      // 接口header--token
      header () {

        return {
          'token': this.token
        }
      },

      // 标题
      upload () {

        switch (this.type) {

          // 形象
          case 'material':
            return {
              'title': '上传形象',
              'name': '形象名称',
              'name_placehodler': '请输入形象名称，最多20个字符',
              'type': '形象类型',
              'type_list': ['标准人物', '简易人物', '四足动物', '自由骨骼'],
              'error_tip': '文件格式错误,仅支持psd、zip格式',
              'url': '/upload/file?_type=prop'
            }
            break

          // 场景
          case 'scene':
            return {
              'title': '上传场景',
              'name': '场景名称',
              'name_placehodler': '请输入场景名称，最多20个字符',
              'type': '场景类型',
              'type_list': [],
              'error_tip': '文件格式错误,仅支持psd、zip格式',
              'url': '/upload/file?_type=prop'
            }
            break

          // 道具
          case 'prop':
            return {
              'title': '上传道具',
              'name': '道具名称',
              'name_placehodler': '请输入道具名称，最多20个字符',
              'type': '道具类型',
              'type_list': ['序列帧'],
              'error_tip': '文件格式错误,图片类型仅支持jpg、png;序列帧类型仅支持psd格式',
              'url': '/upload/file?_type=prop'
            }
            break

          // 背景音乐
          case 'bgm':
            return {
              'title': '上传背景音乐',
              'name': '背景音乐名称',
              'name_placehodler': '请输入背景音乐名称，最多20个字符',
              'type': '背景音',
              'type_list': [],
              'error_tip': '背景音乐文件格式错误，仅支持mp3格式',
              'url': '/upload/file?_type=bgm'
            }
            break
        }
      },

      // 保存按钮状态
      saveStatus () {

        if(0 < this.error_info.length)
        {
          return true;
        }

        if(this.type == 'material' || this.type == 'prop'){

          if(this.type == 'material' && this.uploading != ''){
            this.ruleForm.name = this.uploading.title
          }

          if(this.file_name != '' && this.ruleForm.name != '' && this.ruleForm.type != ''){

            return false
          }else{
            // console.log('上传保存按钮的状态 ==> ' + this.file_name + 'aaa ='+ this.ruleForm.name + 'bbb ='+this.ruleForm.type)
            return true
          }
        }else{

          if(this.file_name != '' && this.ruleForm.name != ''){

            return false
          }else{

            return true
          }
        }

      },
      getWidth () {

        return 'width:' + this.percent*4 + 'px'
      }
    },
    props: ['token','type','teamid', 'handle' , 'folderid', 'uploading',],// uploading 重新上传的标记
    data () {
      return {

        upload_loading: false,

        file_name: '',

        percent: '',

        upload_progress: null,


        fileList: [],

        ruleForm: {
          name: '',
          type:''
        },

        rules: {
          name: [
            { required: true, message: '请输名称', trigger: 'blur' },
            { min: 1, max: 20, message: '名称不能超过20字符', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
          ],
        },

        upload_id: '',

        get_status_time: null,

        error_info: [],

        save_status: false,

        upload_status: false,

        video_urls: [
          '/video/material-template.v3.mp4',
          '/video/material-upload.v3.mp4',
          '/video/scene.v3.mp4'
        ],

        dialog_video_visible: false,

        video_url: '',
        // 上传到的文件夹
        // upload_folder_id:'',


      }
    },
    methods: {

      // 教学视频播放
      handleVideoPlay (index){

        this.dialog_video_visible = true

        this.video_url = this.video_urls[index]

        setTimeout(() => {
          let video = document.getElementById('video_upload')

          video.play()
        })
      },

      // 上传前的判断--类型--大小
      handleBeforeUpload ( file){
         this.error_info = [] ;
        // 判断大小
        if(file.size/1024/1024 > 100){

          this.error_info = ['文件大小超出上限,最大可上传100M的文件']
          return false
        }
        let lastIndex = file.name.lastIndexOf(".")
        var filextension = file.name.substring(lastIndex,file.name.length)
        filextension = filextension.toLowerCase();
        console.log('upload file type : '  + this.type + '   suffix :  ' + filextension)
        // 形象/场景--psd--zip
        if(this.type == 'material' || this.type == 'scene'){

          // if(file.name.indexOf('zip') > 0 || file.name.indexOf('psd') > 0){
          if(filextension == '.zip' || filextension == '.psd'){  

          }else{
            this.error_info = ['文件格式错误,仅支持psd、zip格式']
            return false
          }
        }

        //道具--支支持上传psd格式的序列帧
        if(this.type == 'prop'){
          if(this.ruleForm.type != ''){
            if(this.ruleForm.type == '序列帧'){
              if(filextension == '.psd'){  
              }else{
                this.error_info = ['文件格式错误,序列帧类型仅支持psd格式']
                return false
              }
            }
          }else{
            this.error_info = ['请选择要上传的文件格式']

          }


        }

        //背景音--mp3
        if(this.type == 'bgm'){

          // if(file.name.indexOf('mp3') > 0 || file.name.indexOf('wav') > 0){
          if(filextension == '.mp3' || filextension == '.wav'){  

          }else{
            this.error_info = ['背景音乐文件格式错误，仅支持mp3格式']
            return false
          }
        }

        this.upload_loading = true

        this.error_info = []
      },

      // 上传进度
      handleProgress (event, file, fileList) {

        this.percent = parseInt(event.percent)

      },

      // 上传成功
      hanldeSuccess (response, file, fileList) {
        this.error_info = []

        let length = file.name.length

        if(length > 10){

          let subStr1 = file.name.substr(0,2)
          let subStr2 = file.name.substr(file.name.length-5,5)
          let subStr = subStr1 + "..." + subStr2
          this.file_name = subStr

        }else{
          this.file_name = file.name
        }

        this.upload_loading = false

        this.percent = 0

        this.upload_id = response.result.id
        // 上传没报错
        if(response.result.errors && response.result.errors.length == 0){
            return true;
        }
        // 预解析报错
        else{

          for(var i=0;i<response.result.errors.length;i++){

            this.error_info.push(response.result.errors[i])
          }
          this.file_name = ''
          return false
        }

      },

      // 保存
      handleSave (formName, id, type, title, info, option) {
        this.$refs[formName].validate((valid) => {

          if (valid) {

            let info = ''

            this.save_status = true

            this.upload_status = true

            this.handleSavePost(this.upload_id, this.type, this.ruleForm.name, info, this.ruleForm.type, this.teamid)
          } else {

          }
        })
      },

      // 返回
      hanadleBack () {

        clearTimeout(this.get_status_time)
        this.$parent.upload = false
        this.$parent.home_uploading_back = true
      },

      // -------------------------------------------[api]------------------------

      handleSavePost (id, type, title, info, option, team_id) {

        this.percent = 0

        let URL = '/upload/save?_type=' + type

        let params = 'id=' + id + '&title=' + title + '&info=' + info + '&option=' + option + '&team_id=' + team_id //+ '&folder_id=' + this.folderid
        if(this.folderid.length>1){
          params = params + '&folder_id=' + this.folderid
        }
        if(this.uploading != ''){
          params = params + '&data_id='+this.uploading.id
        }
        console.log('上传的参数 ===> ' + JSON.stringify(params) + ' <===> ' + URL + '==' + this.folderid)
        let headers = {
          'token': this.token,
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
        this.AJAX.post(URL, headers, params).then((data)=>{
          this.handleGetUploadStatus(id)
        })
        .catch((err)=>{
          this.folderid = ''
          this.$message({
              message: err.msg||err.message,
              type: 'error'
          })
        })
      },

      handleGetUploadStatus (id) {

       let URL = process.env.HOST + '/pro/api/upload/getStatus'
       let headers = {
          'token': this.token
        }

        let params = {
          'id': id,
        }
        this.AJAX.get(URL, headers, params).then((data)=>{
          // 保存成功
          if(data.result.todo == 'end'){

            if(data.result.errors.length == 0){
              this.upload_status = false
              this.save_status = false
              this.folderid = ''
              this.uploading = ''
              this.error_info = ['保存成功']
              if(-1 < ['prop','bgm'].indexOf(this.type))
              {
                    setTimeout (() => {
                       return   this.$parent.upload = false
                      },1000)

              }
              else{

                setTimeout (() => {
                  this.$parent.upload = false
                  this.handle(data.result.dataId, this.ruleForm.name, this.type)
                },1000)

              }

              return false
            }
            // 失败
            else{

              this.save_status = false
              this.upload_status = false
              this.folderid = ''
              this.uploading = ''
              for(var i=0;i<data.result.errors.length;i++){

                this.error_info.push(data.result.errors[i])
              }
              return false
            }


          }else{

            // 保存中
              this.error_info = ['处理中。。。。']

              this.get_status_time = setTimeout(() => {

                this.handleGetUploadStatus(id)
              },5000)
          }
        })
      }
    },
    watch: {
      'dialog_video_visible':function () {
        if(!this.dialog_video_visible){

          let video = document.getElementById('video_upload')

          video.pause()
        }
      }
    },
    mounted () {

    }
  }
</script>
<style>
/* .el-form .el-form-item__label{
  color:#fff;
} */
</style>
<style lang="stylus" scoped>
  .upload
    position: absolute
    top: 69px
    right: 0
    bottom: 0
    left: 210px
    overflow: auto
    padding 20px
    .back_btn
      position absolute
      top 20px
      left 10px
    .title
      font-size 18px
      text-align center
      width 500px
      margin 0 auto
      margin-bottom 36px
      color:#fff
    .el-form
      width 500px
      margin 0 auto
      .save-btn
        width 220px
        color #fff
        margin-left 90px
        border-radius 5px
      .el-button--success
        background #7AB3F6
        border-color #7AB3F6
        color #fff
      .is-loading
        background #199ed7
        color #fff
      .upload-btn
        background #f99b05
        border-radius 14px
        border none
        width 90px
      .is-disabled
        background #bfcbd9
        border-color #bfcbd9
        cursor: not-allowed
        color #fff
      .video-play
        cursor pointer
        line-height 26px
        margin-left 20px
        color #4a90e2
        text-decoration:underline
      .progress
        height 10px
        width 400px
        border-radius 5px
        margin 0 auto
        border 1px solid #eee
        position relative
        margin-bottom 24px
        div
          position absolute
          top 0
          left 0
          background #ffa225
          height 10px
          border-radius 5px
      .percent
        width 400px
        text-align center
        margin 0 auto
        margin-bottom 12px

</style>



// WEBPACK FOOTER //
// Upload.vue?73989c9f